var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 4.00021H15.3333C15.5101 4.00021 15.6797 3.92997 15.8047 3.80494C15.9298 3.67992 16 3.51035 16 3.33354C16 3.15673 15.9298 2.98716 15.8047 2.86214C15.6797 2.73711 15.5101 2.66688 15.3333 2.66688H4.66667C4.48986 2.66688 4.32029 2.73711 4.19527 2.86214C4.07024 2.98716 4.00001 3.15673 4.00001 3.33354C4.00001 3.51035 4.07024 3.67992 4.19527 3.80494C4.32029 3.92997 4.48986 4.00021 4.66667 4.00021Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 7.33314H4.66667C4.48986 7.33314 4.32029 7.40337 4.19527 7.5284C4.07024 7.65342 4.00001 7.82299 4.00001 7.99981C4.00001 8.17662 4.07024 8.34619 4.19527 8.47121C4.32029 8.59624 4.48986 8.66648 4.66667 8.66648H15.3333C15.5101 8.66648 15.6797 8.59624 15.8047 8.47121C15.9298 8.34619 16 8.17662 16 7.99981C16 7.82299 15.9298 7.65342 15.8047 7.5284C15.6797 7.40337 15.5101 7.33314 15.3333 7.33314Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 12H4.66667C4.48986 12 4.32029 12.0702 4.19527 12.1953C4.07024 12.3203 4.00001 12.4899 4.00001 12.6667C4.00001 12.8435 4.07024 13.0131 4.19527 13.1381C4.32029 13.2631 4.48986 13.3333 4.66667 13.3333H15.3333C15.5101 13.3333 15.6797 13.2631 15.8047 13.1381C15.9298 13.0131 16 12.8435 16 12.6667C16 12.4899 15.9298 12.3203 15.8047 12.1953C15.6797 12.0702 15.5101 12 15.3333 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 4.66666C2.06971 4.66666 2.66667 4.06971 2.66667 3.33333C2.66667 2.59695 2.06971 2 1.33333 2C0.596954 2 0 2.59695 0 3.33333C0 4.06971 0.596954 4.66666 1.33333 4.66666Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 9.33354C2.06971 9.33354 2.66667 8.73658 2.66667 8.00021C2.66667 7.26383 2.06971 6.66688 1.33333 6.66688C0.596954 6.66688 0 7.26383 0 8.00021C0 8.73658 0.596954 9.33354 1.33333 9.33354Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 13.9998C2.06971 13.9998 2.66667 13.4028 2.66667 12.6665C2.66667 11.9301 2.06971 11.3331 1.33333 11.3331C0.596954 11.3331 0 11.9301 0 12.6665C0 13.4028 0.596954 13.9998 1.33333 13.9998Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.db0d34def124113bdd18cf13818721de.svg";
export { ForwardRef as ReactComponent };